

export default {
    wx_share: '/api/web/v2/share',
    upload: '/api/web/v2/subject/upload'
}
